<div class="configuration-viewer-page">
  <div class="configuration-viewer-side configuration-viewer">
    <div class="eidos-config-list">
      <div class="configuration-viewer-block">
        <h3 class="eidos-list-subheader">Configuration</h3>
        <div class="configuration-item-root" *ngFor="let entry of objectEntries(config)">
          <eidos-configuration-item-viewer [entry]="entry" [fakeConfig]="fakeConfig"></eidos-configuration-item-viewer>
        </div>
      </div>
    </div>
  </div>
  <div class="configuration-viewer-side versions-viewer">
    <div class="eidos-config-list">
      <div class="configuration-viewer-block" *ngIf="apps && apps.length > 0">
        <h3 class="eidos-list-subheader">Configuration</h3>
        <div class="configuration-item-root" *ngFor="let entry of objectEntries(apps)">
          <eidos-configuration-item-viewer [entry]="entry" [fakeConfig]="apps"></eidos-configuration-item-viewer>
        </div>
      </div>
      <div class="configuration-viewer-block">
        <h3 class="eidos-list-subheader">Core version {{ isDevMode() ? '(infos can be out of date in dev mode)' : ''}}</h3>
        <div title="{{eventuallyDisplayDateAndTime(entry[1])}}" class="configuration-item-root" *ngFor="let entry of objectEntries(Version)">
          <div class="eidos-list-item">
            <div class="eidos-list-line">
              <b>{{ entry[0] + ': '}}</b>{{ eventuallyDisplayDateAndTime(entry[1]) }}
            </div>
          </div>
        </div>
      </div>
      <div class="configuration-viewer-block" *ngIf="myBizVersion">
        <h3 class="eidos-list-subheader">MyBiz version</h3>
        <content *ngIf="!!myBizVersion.apiVersion">
          API version
          <div class="configuration-item-root" *ngFor="let entry of objectEntries(myBizVersion.apiVersion)">
            <eidos-configuration-item-viewer [entry]="entry"></eidos-configuration-item-viewer>
          </div>
        </content>
        <content *ngIf="!!myBizVersion.dbVersion">
          DB version
          <div class="configuration-item-root" *ngFor="let entry of objectEntries(myBizVersion.dbVersion)">
            <eidos-configuration-item-viewer [entry]="entry"></eidos-configuration-item-viewer>
          </div>
        </content>
      </div>
      <div class="configuration-viewer-block" *ngIf="versions && versions.length">
        <h3 class="eidos-list-subheader">External apps version</h3>
        <div class="configuration-item-root" *ngFor="let app of versions">
          <div class="eidos-list-item">
            <div class="eidos-list-line">
              <b>{{ app.source + ': '}}</b>{{ app.version }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
